<template>
  <v-layout
    class="add-new-account"
    row
    justify-center>
    <v-dialog
      v-model="financeDialog.show"
      persistent
      scrollable
      max-width="800px">
      <v-card>
        <v-card-title>Edit {{ financeDialog.fields.LinkedAccountName }} ( {{ financeDialog.fields.LinkedAccountId }} )</v-card-title>
        <v-divider />
        <v-card-text>
          <v-container>
            <v-form ref="financeForm">
              <v-flex xs12 sm12 md12 xl12>
                <v-alert
                  v-model="financeDialog.showResponse"
                  :dismissible="true"
                  :type="financeDialog.responseType"
                  class="mb-3"
                >{{ financeDialog.responseMessage }}</v-alert>
              </v-flex>
              <v-flex xs12 sm12 md12 xl12>
                <v-text-field
                  label="Payer Account Id"
                  v-model="financeDialog.fields.PayerAccountId"
                  disabled
                ></v-text-field>
              </v-flex>
               <v-flex xs12 sm12 md12 xl12>
                <v-text-field
                  label="Linked Account Id"
                  v-model="financeDialog.fields.LinkedAccountId"
                  disabled
                ></v-text-field>
               </v-flex>
              <v-flex xs12 sm12 md12 xl12>
                <v-text-field
                  label="Linked Account Name"
                  v-model="financeDialog.fields.LinkedAccountName"
                  disabled
                ></v-text-field>
              </v-flex>
               <v-flex xs12 sm12 md12 xl12>
                <v-text-field
                  label="Service Period"
                  v-model="financeDialog.fields.Service_Period"
                  disabled
                ></v-text-field>
               </v-flex>
              <v-flex xs12 sm12 md12 xl12>
                <v-text-field
                  label="Service Product"
                  disabled
                  v-model="financeDialog.fields.Service_Product"
                ></v-text-field>
              </v-flex>
               <v-flex xs12 sm12 md12 xl12>
                <v-text-field
                  label="CloudCheckr Cost"
                  v-model="financeDialog.fields.CloudCheckr_Cost"
                  disabled
                ></v-text-field>
               </v-flex>
              <!-- <v-text-field
                    label="Additional Discount"
                    v-model="financeDialog.fields.Additional_Discount"
              ></v-text-field>-->
               <v-flex xs12 sm12 md12 xl12>
                <v-text-field label="Uplift" v-model="financeDialog.fields.Uplift"></v-text-field>
               </v-flex>
              <v-flex xs12 sm12 md12 xl12>
                <v-text-field label="Credit Backbill" v-model="financeDialog.fields.Credit_Backbill"></v-text-field>
              </v-flex>
              <!-- <v-text-field
                    label="Total Costs to Allocate"
                    v-model="financeDialog.fields.Total_Costs_to_Allocate"
                  ></v-text-field>
                  <v-text-field
                    label="Estimated Monthly Revenue"
                    v-model="financeDialog.fields.Estimated_Monthly_Revenue"
                  ></v-text-field>
                  <v-text-field
                    label="Estimated Twelve Month Revenue"
                    v-model="financeDialog.fields.Estimated_Twelve_Month_Revenue"
              ></v-text-field>-->
              <!-- <v-text-field
                    label="Can Allocate"
                    v-model="financeDialog.fields.Can_Allocate"
              ></v-text-field>-->
              <v-flex xs12 sm12 md12 xl12>
                <v-select
                  attach
                  :items="['Yes', 'No']"
                  label="Can Allocate"
                  v-model="financeDialog.fields.Can_Allocate"
                ></v-select>
               </v-flex>
               <v-flex xs12 sm12 md12 xl12>
                <v-text-field label="WBS" v-model="financeDialog.fields.WBS"></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12 xl12>
                <v-text-field label="WBS End Date" v-model="financeDialog.fields.WBS_End_Date"></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12 xl12>
                <v-text-field label="IWO Number " v-model="financeDialog.fields.IWO_Number"></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12 xl12>
                <v-text-field
                  label="Originating Org WBS"
                  v-model="financeDialog.fields.Originating_Org_WBS"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12 xl12>
                <v-text-field label="Cost Center" v-model="financeDialog.fields.Cost_Center"></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12 xl12>
                <v-text-field label="Client Name" v-model="financeDialog.fields.Client_Name"></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12 xl12>
                <v-text-field
                  label="Horizon Client Name"
                  v-model="financeDialog.fields.Horizon_Client_Name"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12 xl12>
                <v-select
                  attach
                  :items="['Yes', 'No']"
                  label="Revenue Missing from Horizon"
                  v-model="financeDialog.fields.Revenue_Missing_from_Horizon"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm12 md12 xl12>
                <v-select
                  :items="['All Region', 'AMS','ANZ','Asia','NCE','SE','UKIIMEA']"
                  label="Region"
                  v-model="financeDialog.fields.Region"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm12 md12 xl12>
                <v-select
                  :items="['External / Revenue Generating', 'Internal / Non-Revenue']"
                  label="Account Type"
                  v-model="financeDialog.fields.Account_Type"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm12 md12 xl12>
                <v-text-field
                  label="Major Offering Code"
                  v-model="financeDialog.fields.Major_Offering_Code"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12 xl12>
                <v-text-field
                  label="Major Offering Name"
                  v-model="financeDialog.fields.Major_Offering_Name"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12 xl12>
                <!-- <v-text-field label="SFDC Opp ID" v-model="financeDialog.fields.SFDC_Opp_ID"></v-text-field> -->
             
                <!-- updated SFDC with validation -->
                <v-text-field 
                label="SFDC Opp ID" 
                v-model="financeDialog.fields.SFDC_Opp_ID"
                :loading='financeDialog.sfdcValidation.validating'
                :success='financeDialog.sfdcValidation.validated'
                :error='!financeDialog.sfdcValidation.validated'
                :messages='financeDialog.sfdcValidation.validationMessage'
                @keypress='validateSfdc' 
                outlined >
                  <template v-slot:append>
                    <v-btn class='my-0' :color="financeDialog.sfdcValidation.validated ? 'orange' : ''" small @click="validateSfdc">
                      <span v-if='!financeDialog.sfdcValidation.validated'>validate</span>
                      <v-icon small v-else>check</v-icon>
                      <!-- <v-icon small v-else>check</v-icon> -->
                    </v-btn>
                  </template>
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12 xl12>
                <v-text-field label="SFDC Opp Status" v-model="financeDialog.fields.SFDC_Opp_Status"></v-text-field>
              </v-flex>
              <!-- <v-text-field
                    label="AWS on Opp"
                    v-model="financeDialog.fields.AWS_on_Opp"
              ></v-text-field>-->
              <v-flex xs12 sm12 md12 xl12>
                <v-select
                  :items="['CSC','ES']"
                  label="Financial System"
                  v-model="financeDialog.fields.Financial_System"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm12 md12 xl12>
                <v-text-field
                  label="Credit Redeemed from AWS"
                  v-model="financeDialog.fields.CR_Redeemed_from_AWS"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12 xl12>
                <v-text-field label="Credit Used to Date" v-model="financeDialog.fields.CR_Used"></v-text-field>
              </v-flex>
              <!-- <v-text-field label="CR Remaining" v-model="financeDialog.fields.CR_Remaining"></v-text-field>  -->
              <v-flex xs12 sm12 md12 xl12>
                <v-select
                  :items="['Credits','Backbill','True-Up','Exception']"
                  label="Exceptions"
                  v-model="financeDialog.fields.Exceptions"
                ></v-select>
              </v-flex>

              <v-flex xs12 sm12 md12 xl12>
                <v-select
                  :items="['2%','3%','7%','12%','23%']"
                  label="AWS Discount"
                  v-model="financeDialog.fields.AWS_Discount"
                ></v-select>
              </v-flex>

              <v-flex xs12 sm12 md12 xl12>
                <v-select
                  :items="['2%','3%','7%','12%','23%']"
                  label="DXC Discount"
                  v-model="financeDialog.fields.DXC_Discount"
                ></v-select>
              </v-flex>

              <v-flex xs12 sm12 md12 xl12>
                <v-select
                  :items="['PPA','SPP','Stand Alone']"
                  label="Contract"
                  v-model="financeDialog.fields.Contract"
                ></v-select>
              </v-flex>

              <v-flex xs12 sm12 md12 xl12>
                <v-text-field label="Notes" v-model="financeDialog.fields.Notes"></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md12 xl12>
                <v-text-field
                  label="Galaxy Service Level"
                  v-model="financeDialog.fields.Galaxy_Service_Level"
                ></v-text-field>
              </v-flex>
            </v-form>
          </v-container>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <div/>
          <div>
            <v-btn
              :loading="financeDialog.saving"
              color="orange"
              @click="financeDialog.submitHandler(financeDialog.fields)"
            >{{ financeDialog.submitLabel }}</v-btn>
            <v-btn
              :disabled="financeDialog.saving"
              @click.stop="onCancel"
            >{{ financeDialog.cancelLabel }}</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import { mapState } from 'vuex'

export default {
  data () {
    return {}
  },
  computed: {
    ...mapState('admin', ['financeDialog'])
  },
  watch: {},
  methods: {
    validateSfdc(){
      let Id =  this.financeDialog.fields.Id
      let SfdcId = this.financeDialog.fields.SFDC_Opp_ID
      let SfdcOppStatus = this.financeDialog.fields.SFDC_Opp_Status
      let financeObj = { 
        Id: Id,
        sfdcId: SfdcId,
        sfdcOppStatus: SfdcOppStatus
      }
      console.log('Id: ', Id)
      console.log('SfdcId: ', SfdcId)
      console.log('SFDC Opportunity Status: ', SfdcOppStatus)
      console.log('----- financeObj -----')
      console.log(financeObj)
      console.log('----------------------')
      this.$store.dispatch('admin/findSfdcId', financeObj)
    },
    onCancel(){
       this.$store.commit('admin/resetFinanceDialog')
    }
  }
}
</script>
<style lang="scss">
</style>
